import { useTranslation } from 'react-i18next';
import { Icon } from '@/components/common/Icon';
import { Card } from '@/components/ui/card';

export function CustomDomainLockedCard() {
  const { t } = useTranslation('customDomains');
  return (
    <Card padding="md" variant="dashed" className="flex items-start gap-3">
      <div className="w-10 h-10 rounded-xl bg-zoovpalelavender text-zooprimary flex items-center justify-center shrink-0">
        <Icon name="Lock" />
      </div>
      <div className="min-w-0">
        <h2 className="text-sm font-bold text-zooindigo">{t('locked.title')}</h2>
        <p className="text-xs text-zoomuted mt-1">{t('locked.description')}</p>
      </div>
    </Card>
  );
}
